import { EyeshadowType } from "./v1";

export const eyeshaowTypeOptions = Object.entries(EyeshadowType)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
